import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl2 = `${httpUrl.host}/gy-apartment`

let api = {
  // 保存配置
  saveConfig: `${baseUrl}/yqInfo/update`,

  // 获取配置
  getConfig: `${baseUrl}/yqInfo/getYqInfo`,

  // 上传图片
  uploadImg: `${baseUrl}/common/uploadImg`,

  // 大屏分页
  getDashboardMangerPage: `${baseUrl2}/dashboardManger/getPage`,

  // 添加大屏
  addDashboardManger: `${baseUrl2}/dashboardManger/add`,

  // 修改大屏
  updateDashboardManger: `${baseUrl2}/dashboardManger/update`,

  // 删除大屏
  deleteDashboardMangerByCodes: `${baseUrl2}/dashboardManger/deleteByCodes`,

  // 获取大屏信息
  getDashboardMangerByCode: `${baseUrl2}/dashboardManger/getByCode`,

  // 获取大屏列表
  getDashboardMangerList: `${baseUrl2}/dashboardManger/getList`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/InterfaceConfig.js